import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';
import { getRoomCredential } from '../services/RoomSession';

// Wait for refresh-token restoration before deciding whether login is needed.
const RequireAuth = ({ children }) => {
    const { user, initializing, sessionUnavailable } = useAuth();
    const { t } = useTranslation();
    const location = useLocation();
    // This only mounts the room UI. The server must still validate the bound
    // membership capability before returning any snapshot or allowing actions.
    const roomId = /^\/play\/([^/]+)\/[^/]+\/?$/.exec(location.pathname)?.[1];
    if (roomId && getRoomCredential(roomId)) return children;
    if (initializing) {
        return (
            <Box className="app-page" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {sessionUnavailable ? <Box sx={{ maxWidth: 480, p: 3, textAlign: 'center' }}>
                    <Typography role="status" sx={{ mb: 2 }}>{t('auth.sessionUnavailable')}</Typography>
                    <Button variant="contained" onClick={() => window.location.reload()}>{t('gameRoom.connectionLost.reload')}</Button>
                </Box> : <LoadingSpinner show />}
            </Box>
        );
    }
    if (!user) return <Navigate to="/login" state={{ returnTo: location.pathname }} replace />;
    return children;
};

export default RequireAuth;
